import type { ReactNode } from 'react';

interface SectionProps {
  eyebrow?: string;
  title?: string;
  children: ReactNode;
  className?: string;
  narrow?: boolean;
  /** Top padding clears the absolute header; first section on a page needs it. */
  first?: boolean;
}

/** Edem section: yellow condensed eyebrow, Montserrat Black uppercase title, left aligned. */
export function Section({
  eyebrow,
  title,
  children,
  className,
  narrow,
  first = true,
}: SectionProps) {
  return (
    <section
      className={`mx-auto px-4 ${first ? 'pt-36' : 'pt-16'} pb-16 ${narrow ? 'max-w-3xl' : 'max-w-6xl'} ${className ?? ''}`}
    >
      {(eyebrow || title) && (
        <header className="mb-10">
          {eyebrow && <p className="text-meta text-lg">{eyebrow}</p>}
          {title && <h1 className="mt-2 text-4xl sm:text-5xl">{title}</h1>}
        </header>
      )}
      {children}
    </section>
  );
}

export function Notice({
  tone = 'info',
  children,
}: {
  tone?: 'info' | 'warning' | 'danger' | 'success';
  children: ReactNode;
}) {
  const tones = {
    info: 'border-white/15 bg-white/5 text-ink-200',
    warning: 'border-yellow-500/50 bg-yellow-500/10 text-ink-50',
    danger: 'border-pink-500/60 bg-pink-500/10 text-ink-50',
    success: 'border-success-500/50 bg-success-500/10 text-ink-50',
  };
  // A full 1px frame in the tone colour, square: the Edem "ticket" look rather
  // than the thick left tab that reads as generated UI.
  return (
    <div role="status" className={`border px-5 py-4 text-base ${tones[tone]}`}>
      {children}
    </div>
  );
}
